import React, { useEffect } from 'react';

const B2CSuccess = () => {
    useEffect(() => {
        // Get the authorization code from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');



        if (error) {
            console.error('B2C authentication error:', error);
            alert('B2C Login Error: ' + error);
            window.location.href = '/login';
            return;
        }

        if (code) {

            sessionStorage.setItem('b2c_auth_code', code);
            sessionStorage.setItem('b2c_state', state);
            sessionStorage.setItem('user_type', 'supplier');
            
            // Redirect to dashboard
            window.location.href = '/dashboard';
        } else {
            // No code received, redirect back to login

            window.location.href = '/login';
        }
    }, []);

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f5f5f5'
        }}>
            <div style={{ 
                textAlign: 'center',
                padding: '40px',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
                <h2 style={{ color: '#810055', marginBottom: '20px' }}>Processing Supplier Login...</h2>
                <p>Please wait while we complete your authentication.</p>
                <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #810055',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '20px auto'
                }}></div>
            </div>
        </div>
    );
};

export default B2CSuccess;